export default {
    parts: state => state.parts,
    activePart: state => state.activePart,
    managePartDialog: state => state.managePartDialog,
    manageDeletePartDialog: state => state.manageDeletePartDialog,
}
